import React, { useState } from "react";
import {
  IoEyeOutline,
  IoPencil,
  IoTrashOutline,
  IoAddCircleOutline,
} from "react-icons/io5";

const Modal = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [step, setStep] = useState(1);
  const [finished, setFinished] = useState(false);
  const [intervention, setIntervention] = useState(null);
  const [reason, setReason] = useState(null);
  const [idea, setIdea] = useState(null);
  const [money, setMoney] = useState(null);
  const [pdf, setPdf] = useState(null);

  const handleFinishedClick = () => {
    setFinished(true);
    setStep(1);
  };

  const handleUnfinishedClick = () => {
    setStep(2);
  };

  const handleAutreInterventionClick = () => {
    setIntervention("Autre Intervention");
    setStep(3);
  };

  const handleDevisClick = () => {
    setIntervention("Devis");
    setStep(3);
  };

  const handleIHaveIdeaClick = () => {
    setIdea("I Have an Idea");
    setStep(4);
  };

  const handleIDontClick = () => {
    setStep(1);
  };

  return (
    <>
      <div className="fixed inset-0 z-10 overflow-y-auto">
        <div
          className="fixed inset-0 w-full h-full bg-black opacity-40"
          onClick={() => setIsModalVisible(false)}
        ></div>
        <div className="flex items-center min-h-screen px-4 py-8">
          <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
            <div className="mt-3 sm:flex">
              <div className="flex items-center justify-center flex-none w-12 h-12 mx-auto bg-green-100 rounded-full">
                <IoAddCircleOutline className="text-green-600" />
              </div>
              <div className="mt-2 text-center sm:ml-4 sm:text-left">
                <h4 className="text-lg font-medium text-gray-800">
                  Nouvelle Réclamations
                </h4>
                <p className="mt-2 text-[15px] leading-relaxed text-gray-500 mb-4">
                  Veuillez remplir toutes les informations requises dans le
                  formulaire pour ajouter une nouvelle réclamations.
                </p>
                <div className="modal-content mr-4">
                  <form className="mr-4 mb-4">
                    <div className="mt-1">
                      <textarea
                        id="claime"
                        name="claime"
                        rows={3}
                        className="mt-1 block w-full rounded-md  border-1 border-gray-200 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm p-4"
                        defaultValue={""}
                        value={"claime"}
                        onChange={"handleClaime"}
                      />
                    </div>
                  </form>
                </div>
                <div className="items-center gap-2 mt-3 sm:flex pb-4 mr-4">
                  <button
                    className="w-full mt-2 p-2.5 flex-1 text-white bg-green-600 rounded-md outline-none ring-offset-2 ring-red-600 focus:ring-2"
                    onClick={"handleSubmit"}
                  >
                    Ajouter
                  </button>
                  <button
                    className="w-full mt-2 p-2.5 flex-1 text-gray-800 rounded-md outline-none border ring-offset-2 ring-indigo-600 focus:ring-2"
                    onClick={() => setIsModalVisible(false)}
                  >
                    Annuler
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
